export class Preisstand {
    preisstand!: number;
    wert!: number;
   }
 

   